<template>
  <div class="message-center-page">
    <div ref="filterBox" class="filter-box">
      <a-form layout="inline" class="demo-form-inline">
        <a-form-item>
          <a-input v-model="form.keyword" placeholder="搜索标题/内容" allow-clear />
        </a-form-item>
        <a-form-item>
          <a-select v-model="form.level" placeholder="请选择级别" allow-clear>
            <a-select-option value="DEBUG">DEBUG</a-select-option>
            <a-select-option value="INFO">INFO</a-select-option>
            <a-select-option value="WARN">WARN</a-select-option>
            <a-select-option value="ERROR">ERROR</a-select-option>
            <a-select-option value="CRITICAL">CRITICAL</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-select v-model="form.is_read" placeholder="请选择已读状态" allow-clear>
            <a-select-option :value="0">未读</a-select-option>
            <a-select-option :value="1">已读</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-select v-model="form.is_process" placeholder="请选择处理状态" allow-clear>
            <a-select-option :value="0">无需处理</a-select-option>
            <a-select-option :value="1">未处理</a-select-option>
            <a-select-option :value="2">已处理</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-range-picker
            v-model="form.dateRange"
            show-time
            format="YYYY-MM-DD HH:mm:ss"
            value-format="YYYY-MM-DD HH:mm:ss"
            :placeholder="['开始时间', '结束时间']"
            separator="至"
          />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="search">查询</a-button>
          <a-button style="margin-left: 10px" @click="reset">重置</a-button>
          <a-button style="margin-left: 10px" @click="batchRead">全部标记已读</a-button>
        </a-form-item>
      </a-form>
    </div>
    <vxe-table :border="true" :data="dataSource" :height="tableHeight" resizable :loading="loading" @cell-click="cellClick">
      <vxe-column field="id" title="ID" width="120" />
      <vxe-column field="level" title="级别" width="100">
        <template #default="{ row }">
          <a-tag v-if="row.level === 'INFO'" color="green">{{ row.level }}</a-tag>
          <a-tag v-else-if="row.level === 'WARN'" color="orange">{{ row.level }}</a-tag>
          <a-tag v-else-if="row.level === 'ERROR' || row.level === 'CRITICAL'" color="red">{{ row.level }}</a-tag>
          <a-tag v-else>{{ row.level }}</a-tag>
        </template>
      </vxe-column>
      <vxe-column field="system" title="系统" width="120" />
      <vxe-column field="module" title="模块" width="120" />
      <vxe-column field="department" title="部门" width="120" />
      <vxe-column field="title" title="标题" min-width="200" show-overflow="tooltip" />
      <vxe-column field="create_time" title="发送时间" width="180" />
      <vxe-column field="is_read" title="已读状态" width="100">
        <template #default="{ row }">
          <a-tag v-if="row.is_read === 0">未读</a-tag>
          <a-tag v-else color="green">已读</a-tag>
        </template>
      </vxe-column>
      <vxe-column field="is_process" title="处理状态" width="100">
        <template #default="{ row }">
          <a-tag v-if="row.is_process === 0">无需处理</a-tag>
          <a-tag v-else-if="row.is_process === 1" color="red">未处理</a-tag>
          <a-tag v-else-if="row.is_process === 2" color="green">已处理</a-tag>
        </template>
      </vxe-column>
    </vxe-table>
    <div class="pagination-wrapper">
      <a-pagination
        v-model="pagination.current"
        size="small"
        :total="pagination.total"
        :page-size="pagination.pageSize"
        :show-total="pagination.showTotal"
        @change="pageChange"
      />
    </div>
    <a-modal title="消息详情" :visible="detailDialogVisible" width="80%" :mask-closable="false" :footer="null" @cancel="detailDialogVisible = false">
      <div v-if="currentRow.id">
        <a-descriptions title="消息属性" :column="2" bordered>
          <a-descriptions-item label="ID">{{ currentRow.id }}</a-descriptions-item>
          <a-descriptions-item label="级别">
            <a-tag v-if="currentRow.level === 'INFO'" color="green">{{ currentRow.level }}</a-tag>
            <a-tag v-else-if="currentRow.level === 'WARN'" color="orange">{{ currentRow.level }}</a-tag>
            <a-tag v-else-if="currentRow.level === 'ERROR' || currentRow.level === 'CRITICAL'" color="red">{{ currentRow.level }}</a-tag>
            <a-tag v-else>{{ currentRow.level }}</a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="系统">{{ currentRow.system }}</a-descriptions-item>
          <a-descriptions-item label="模块">{{ currentRow.module }}</a-descriptions-item>
          <a-descriptions-item label="部门">{{ currentRow.department }}</a-descriptions-item>
          <a-descriptions-item label="发送时间">{{ currentRow.create_time }}</a-descriptions-item>
        </a-descriptions>
        <a-descriptions title="消息详情" :column="1" bordered style="margin-top: 20px">
          <a-descriptions-item label="标题">
            <message-content mode="inline" :content="currentRow.title" />
          </a-descriptions-item>
          <a-descriptions-item label="消息">
            <div class="message-detail-content">
              <message-content :content="currentRow.message" />
            </div>
          </a-descriptions-item>
        </a-descriptions>
        <div class="dialog-actions">
          <a-button v-if="currentRow.is_process === 1" type="primary" @click="handleProcess">标记已处理</a-button>
          <a-button style="margin-left: 10px" @click="detailDialogVisible = false">关闭</a-button>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { getMessageList, updateMessage } from '@/api/notice'
import MessageContent from '@/components/MessageContent'

export default {
  components: { MessageContent },
  data() {
    return {
      dataSource: [],
      tableHeight: null,
      loading: false,
      detailDialogVisible: false,
      messageDialogVisible: false,
      selectedMessage: '',
      currentRow: {},
      pagination: {
        current: 1,
        pageSize: 20,
        total: 0,
        showTotal: total => `共 ${total} 条`
      },
      form: {
        keyword: '',
        level: undefined,
        is_read: undefined,
        is_process: undefined,
        dateRange: null
      }
    }
  },
  created() {
    this.fetchData()
  },
  mounted() {
    this.calcTableHeight()
    window.addEventListener('resize', this.calcTableHeight)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calcTableHeight)
  },
  methods: {
    fetchData(params = {}) {
      this.loading = true
      const query = {
        page_num: this.pagination.current,
        page_size: this.pagination.pageSize,
        ...this.buildQuery(),
        ...params
      }
      getMessageList(query)
        .then(res => {
          this.loading = false
          if (res.code === 0) {
            this.dataSource = res.data.list
            this.pagination.total = res.data.total
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    buildQuery() {
      const query = {}
      if (this.form.keyword) {
        query.title = this.form.keyword
        query.message = this.form.keyword
      }
      if (this.form.level) {
        query.level = this.form.level
      }
      if (this.form.is_read !== null && this.form.is_read !== undefined) {
        query.is_read = this.form.is_read
      }
      if (this.form.is_process !== null && this.form.is_process !== undefined) {
        query.is_process = this.form.is_process
      }
      if (this.form.dateRange && this.form.dateRange.length === 2) {
        query.start_time = this.form.dateRange[0]
        query.end_time = this.form.dateRange[1]
      }
      return query
    },
    search() {
      this.pagination.current = 1
      this.fetchData()
    },
    reset() {
      this.form = {
        keyword: '',
        level: undefined,
        is_read: undefined,
        is_process: undefined,
        dateRange: null
      }
      this.pagination.current = 1
      this.fetchData()
    },
    pageChange(e) {
      this.pagination.current = e
      this.fetchData()
    },
    cellClick(row) {
      this.currentRow = row.row
      this.detailDialogVisible = true
      if (this.currentRow.is_read === 0) {
        this.markAsRead(this.currentRow.id)
      }
    },

    markAsRead(id) {
      updateMessage(id, { is_read: 1 }).then(() => {
        this.currentRow.is_read = 1
        this.fetchData()
      })
    },
    handleProcess() {
      if (!this.currentRow.id) return
      updateMessage(this.currentRow.id, { is_process: 2 }).then(() => {
        this.currentRow.is_process = 2
        this.fetchData()
      })
    },
    batchRead() {
      // TODO: 批量标记已读
      this.$message.success('全部标记已读')
    },
    calcTableHeight() {
      const pageHeight = window.innerHeight
      const headerHeight = 64
      const contentMargin = 48
      const contentPadding = 48
      const filterBox = this.$refs.filterBox
      const filterHeight = filterBox ? filterBox.offsetHeight : 52
      const paginationHeight = 52
      const extraGap = 20
      this.tableHeight = pageHeight - headerHeight - contentMargin - contentPadding - filterHeight - paginationHeight - extraGap
    }
  }
}
</script>

<style scoped>
.message-center-page {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.filter-box {
  margin-bottom: 10px;
  flex-shrink: 0;
}

.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  flex-shrink: 0;
}

.dialog-actions {
  margin-top: 20px;
  text-align: center;
}

.message-detail-content {
  padding: 16px;
  background-color: #f5f7fa;
  border-radius: 4px;
  line-height: 1.6;
  max-height: 500px;
  overflow-y: auto;
}
</style>
